
import React from "react";
import firebase from 'firebase/compat/app';
import { defaultUserData, UserData } from "../firebaseSetup";

export const AuthContext = React.createContext<firebase.User | null>(null);
export const UserContext = React.createContext<UserData>(defaultUserData);

